import  { lazy, Suspense } from "react";

const KendoDialog = lazy(() =>
  import("@progress/kendo-react-dialogs").then((mod) => ({ default: mod.Dialog }))
);

interface DialogOnlyWrapperProps {
  children: React.ReactNode;
}

const DialogOnlyWrapper: React.FC<DialogOnlyWrapperProps> = ({ children }) => {
  return (
    <Suspense fallback={<div />}>
      <div className="gx-modal-wrap">
        <KendoDialog className="!backdrop-blur-sm">{children}</KendoDialog>
      </div>
    </Suspense>
  );
};

export default DialogOnlyWrapper;
